import React, { Fragment, useEffect, useState } from 'react';
import ButtonClose from '../ButtonClose';
import { TbCircleCheckFilled, TbZoom } from 'react-icons/tb';
import { useStoreContext } from '../../../Contexts/StoreContext';
import { useCartContext } from '../../../Contexts/CartContext';
import Scrollbars from 'react-custom-scrollbars-2';
import ButtonPrimary from '../../Form/ButtonPrimary';
import Button from '../../Form/Button';
import { MdTableRestaurant } from 'react-icons/md';
import { IMaskInput } from 'react-imask';
import { normalizeStringToSearch } from '../../../Utils/Helpers';
import Badge from '../Badge';
import { useCartHook } from '../../../Hooks/CartHook';
import { useStoreHook } from '../../../Hooks/StoreHook';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';

interface TableChoiceProps {
    onShowConfirmTable?: CallableFunction;
}

const TableChoice = ({
    onShowConfirmTable,
}: TableChoiceProps) => {

    const { tables, table, setTable, requiredTable } = useStoreContext();
    const { cartDisplay, setCartDisplay, showTablesToChoice, setShowTablesToChoice, setShowConfirmTable } = useCartContext();
    const [showShadow, setShowShadow] = useState(false);
    const [currentTable, setCurrentTable] = useState<any | null>(null);
    const [searchTerm, setSearchTerm] = useState("");
    const { handleSend } = useCartHook();
    const { updateCartTable } = useStoreHook();

    const handleScrollFrame = (values: any) => {
        const { scrollTop, scrollHeight, clientHeight } = values;
        // Verifica se o scroll está no início ou no fim para controlar a sombra
        if (scrollTop >= 0 && scrollTop + clientHeight < scrollHeight) {
            setShowShadow(true);
        } else {
            setShowShadow(false);
        }
    }

    useEffect(() => {
        //* Exibição da sombra dos itens quando houver scroll
        const boxScroll = document.getElementById('boxScroll');
        const scrollContent = document.getElementById('scrollContent');

        if (boxScroll && scrollContent) {
            const boxScrollHeight = boxScroll.getBoundingClientRect().height;
            const scrollContentHeight = scrollContent.getBoundingClientRect().height;
            setShowShadow(scrollContentHeight > boxScrollHeight)
        }

        //* Utilizado para exibir seleção de mesas quando não houve mesas selecionada no state
        setShowTablesToChoice(!cartDisplay?.table || !cartDisplay.table.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tables])

    const handleUpdateCartTable = (table: any) => {
        setShowConfirmTable(false);
        updateCartTable(table.id)
    }

    const handleChangeTable = (table: any) => {
        setCurrentTable(table);

        if (cartDisplay) {
            setCartDisplay((prevState: any) => ({
                ...prevState,
                table: {
                    ...prevState.table,
                    id: table.id,
                    name: table.name
                }
            }));

            //* Usado na abertura da comanda quando não tem mesa informada
            if (requiredTable) {
                handleUpdateCartTable(table);
            } else {
                setShowConfirmTable(false);
            }
        } else {
            setTable(table.id);
        }
    }

    const filterTables = (tables: [], searchTerm: string) => {
        return tables.reduce((filtered: any[], category: any) => {
            const filteredTables = category.tables.filter((table: any) =>
                normalizeStringToSearch(table.name).includes(normalizeStringToSearch(searchTerm))
            );
            if (filteredTables.length > 0) {
                filtered.push({ ...category, tables: filteredTables });
            }
            return filtered;
        }, []);
    };
    const filteredTables = filterTables(tables, searchTerm);

    useEffect(() => {
        if(!showTablesToChoice) {
            setSearchTerm('');
        }; 
    }, [showTablesToChoice]);

    return (
        <>
            {(cartDisplay && !requiredTable) && <ButtonClose onClick={() => onShowConfirmTable!(false)} />}
            <div className='flex h-full flex-col justify-between'>
                <div className='p-4 pt-6 flex flex-col items-center'>
                    <MdTableRestaurant size={40} className='zoomInIcon' />
                    <div className='flex flex-col w-full gap-2 mt-2'>
                        <span className="font-extrabold w-full text-center text-2xl leading-6 text-shopfood-alert">
                            {!showTablesToChoice ? 'Confirme a sua mesa' : 'Informe em qual mesa você está no momento.'}
                        </span>
                        {!showTablesToChoice &&
                            <span className="font-bold w-full text-center text-base leading-5 px-2">
                                Precisamos desta informação para que o pedido chegue até você ;)
                            </span>
                        }

                        {showTablesToChoice &&
                            <div className="relative flex items-center mt-2">
                                <TbZoom className="pointer-events-none absolute left-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
                                <IMaskInput
                                    id="searchTerm"
                                    name="searchTerm"
                                    mask={/^[a-zA-ZÀ-ÿ0-9\s]*$/}
                                    value={searchTerm}
                                    onAccept={(value) => setSearchTerm(value)}
                                    unmask={true} // true|false|'typed'
                                    placeholder="Procure sua mesa"
                                    className="block w-full rounded border-0 p-2 pl-9 ring-1 ring-gray-300 placeholder:font-normal placeholder:text-sm placeholder:text-gray-400 font-bold focus:ring-2 focus:ring-gray-500 transition-all ease-in-out duration-200"
                                />
                                {(showTablesToChoice && cartDisplay?.table?.name) &&
                                    <Badge type={'custom'} className="text-nowrap absolute right-3 font-extrabold text-xs">
                                        {cartDisplay?.table?.name}
                                    </Badge>
                                }
                            </div>
                        }

                    </div>
                </div>

                {!showTablesToChoice &&
                    <div className='flex flex-col gap-1 items-center justify-center w-full h-full p-6 bg-gray-100'>
                        <span className='text-4xl font-black fadeInIcon'>{cartDisplay && cartDisplay.table.id ? cartDisplay?.table?.name : currentTable ? currentTable.name : ''}</span>
                        <div className='w-full text-center leading-4'>Este será o local de entrega do seu pedido.</div>
                    </div>
                }

                {(!showTablesToChoice && cartDisplay?.table?.name) &&
                    <span className='text-sm w-full text-center leading-4 p-4'>
                        O <span className='font-bold'>nome ou número da sua mesa</span> deve estar em um display ou colado na própria mesa.
                    </span>
                }

                {showTablesToChoice &&
                    <div className='relative h-full min-h-24' id="boxScroll">
                        <Scrollbars autoHide={false} onScrollFrame={handleScrollFrame} className=''>
                            <div className="p-4 pt-0 pb-2" id='scrollContent'>
                                {
                                    filteredTables?.map((tableCategory: any, index: number) => (
                                        <Fragment key={index} >
                                            <div className={`text-lg font-extrabold flex items-center gap-4 ${index > 0 && 'mt-6'} mb-3`}>
                                                <hr className='w-full' />
                                                <span className='text-nowrap leading-5 text-custom-primary'>{tableCategory.name}</span>
                                                <hr className='w-full' />
                                            </div>
                                            <div className='grid grid-cols-3 gap-2 w-full text-sm'>
                                                {tableCategory.tables.map((table: any, index: number) => 
                                                    <Fragment key={index}>
                                                        {(cartDisplay && cartDisplay.table && parseInt(table.id) === parseInt(cartDisplay.table.id)) || (currentTable?.id === parseInt(table.id))
                                                            ? 
                                                                <ButtonPrimary outline onClick={() => {}} className='relative rounded-md w-full pointer-events-none'>
                                                                    <TbCircleCheckFilled size={18} className='absolute -right-1.5 -top-1.5 rounded-full' />
                                                                    {table?.name}
                                                                </ButtonPrimary>
                                                            : <Button onClick={() => handleChangeTable(table)} className='w-full rounded-md'>{ table.name }</Button>
                                                        }
                                                    </Fragment>
                                                )}
                                            </div>
                                        </Fragment>
                                    ))
                                }
                            </div>
                            <BoxContentEndScrollbars message='Fim das mesas' />
                        </Scrollbars>
                        <div className={`absolute bottom-0 mt-2 w-full h-2 bg-white shadow-reverse-md transition ${showShadow ? 'opacity-100' : 'opacity-0'}`}></div>
                    </div>
                }

                {(cartDisplay.table.id && (cartDisplay?.table || table) && !requiredTable) &&
                    <div className='flex w-full gap-2 justify-center p-4'>
                        <ButtonPrimary outline onClick={() => setShowTablesToChoice(!showTablesToChoice)} className='text-sm w-full'>
                            {!showTablesToChoice ? 'Mudar mesa' : 'Cancelar'}
                        </ButtonPrimary>
                        <ButtonPrimary 
                            onClick={handleSend} className='text-sm w-full'
                            disabled={(!cartDisplay?.table && !table) || !cartDisplay.table.id}
                            >
                            Está correta
                        </ButtonPrimary>
                    </div>
                }

            </div>
        </>
    );
};

export default TableChoice;
